module.exports = __webpack_public_path__ + "img/6.e308c9aa.png";